export enum CatalogColorStatus {
    Black = 1,
    Blue = 2,
    Green = 3,
    Error = 4
}
